import { createAppKit } from '@reown/appkit/react';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import {
  mainnet,
  polygon,
  bsc,
  arbitrum,
  optimism,
  avalanche,
  base,
  sepolia,
  polygonAmoy,
  bscTestnet,
  arbitrumSepolia,
  optimismSepolia,
  avalancheFuji,
  baseSepolia
} from '@reown/appkit/networks';

const projectId = process.env.REACT_APP_THIRD_WEB_PROJECT_ID;

if (!projectId) {
  console.warn('REACT_APP_THIRD_WEB_PROJECT_ID is not set. Wallet connection may not work.');
}

const queryClient = new QueryClient();

const networks = [
  mainnet,
  polygon,
  bsc,
  arbitrum,
  optimism,
  avalanche,
  base,
  sepolia,
  polygonAmoy,
  bscTestnet,
  arbitrumSepolia,
  optimismSepolia,
  avalancheFuji,
  baseSepolia
];

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false
});

const metadata = {
  name: 'MaxelPay',
  description: 'Crypto Payment Gateway',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://maxelpay.com',
  icons: ['https://avatars.githubusercontent.com/u/179229932']
};

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true,
    email: false,
    socials: false
  },
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#7c3aed',
    '--w3m-border-radius-master': '2px'
  }
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

export function Web3Provider({ children }) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}
